import React, { useCallback } from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";
import cn from "classnames";
import { useIntl } from "react-intl";

import { Button, Modal } from "@mapmycustomers/ui";

import mmcFieldInfoImage from "@app/assets/imports/mmcFieldInfo.svg";
import layout from "@app/styles/layout";

import styles from "./MmcFieldInfoModal.module.scss";

interface Props {
  onHide: () => void;
  visible: boolean;
}

const MmcFieldInfoModal: React.FC<Props> = ({ onHide, visible }) => {
  const intl = useIntl();

  const handleInfoClick = useCallback(() => {
    onHide();
    window.open("https://support.mapmycustomers.com/hc/en-us/articles/360047011454");
  }, [onHide]);

  return (
    <Modal
      footer={
        <Row gutter={layout.spacerL} justify="end" key="info">
          <Col>
            <Button onClick={handleInfoClick} type="link">
              {intl.formatMessage({
                id: "settings.newImports.mmcFieldInfoModal.footer.whatAreCustomFields",
                defaultMessage: "What are Custom Fields?",
                description: "Text of information link button",
              })}
            </Button>
          </Col>
          <Col>
            <Button key="submit" onClick={onHide} type="primary">
              {intl.formatMessage({
                id: "settings.newImports.mmcFieldInfoModal.footer.gotIt",
                defaultMessage: "Got it!",
                description: "Text of GOT IT button",
              })}
            </Button>
          </Col>
        </Row>
      }
      onCancel={onHide}
      title={intl.formatMessage({
        id: "settings.newImports.mmcFieldInfoModal.title",
        defaultMessage: "Matching fields",
        description: "Title MMC field info modal (imports)",
      })}
      visible={visible}
    >
      <div>
        {intl.formatMessage(
          {
            id: "settings.newImports.mmcFieldInfoModal.body",
            defaultMessage:
              "<p>To connect an imported column to a field in Map My Customers, click the dropdown menu and select the relevant field. Please note, many fields may be automatically mapped by default.</p><h4>To create a custom field:</h4><p>If there is no current Map My Customers field to map, you may opt to “Create a new custom field” in the dropdown. Selecting this option creates a new field in Map My Customers, carrying over the name of the column header. All imported custom fields will be a text field by default.</p>{img}<p>You can edit or adjust custom fields in Settings by clicking on the gear icon.</p>",
            description: "Mmc Field Info Modal text (imports)",
          },
          {
            h4: (text: string) => (
              <h4 className={cn([styles.paragraph, styles.middleText])}>{text}</h4>
            ),
            img: (
              <img
                alt="field mapping screenshot"
                className={styles.image}
                src={mmcFieldInfoImage}
              />
            ),
            p: (text: string) => <p className={styles.paragraph}>{text}</p>,
          }
        )}
      </div>
    </Modal>
  );
};

export default MmcFieldInfoModal;
